import React from 'react';
import {
  AppleFilled,
  AndroidFilled,
  MobileOutlined,
  ProfileOutlined,
  SearchOutlined,
  ThunderboltOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import logo from '../assets/images/bg/logo.svg';
import './AppDownloadHero.css';

const FEATURES = [
  { icon: <SearchOutlined />, label: 'Browse open jobs' },
  { icon: <ThunderboltOutlined />, label: 'Apply in minutes' },
  { icon: <CalendarOutlined />, label: 'Pick up shifts' },
];

const AppDownloadHero = ({
  embedded = false,
  welcomeName,
  title = "You're ready to find your next shift",
  subtitle = 'Download the VitalStaf app to browse open jobs, apply in minutes, and get matched to shifts that fit your schedule.',
  hint = 'Open the app, apply to jobs, and start picking up shifts today.',
  showOpenInApp = false,
  onOpenInApp,
  showProfileButton = false,
  onProfileClick,
  loading = false,
  loadingText = 'Opening the VitalStaf app…',
}) => (
  <section className={`app-hero${embedded ? ' app-hero--embedded' : ''}`}>
    <div className="app-hero__glow app-hero__glow--one" aria-hidden />
    <div className="app-hero__glow app-hero__glow--two" aria-hidden />

    <div className="app-hero__inner">
      {!embedded ? (
        <img src={logo} alt="VitalStaf" className="app-hero__logo" />
      ) : null}

      {loading ? (
        <div className="app-hero__loading">
          <div className="app-hero__spinner" role="status" aria-label="Loading" />
          <p className="app-hero__loading-text">{loadingText}</p>
        </div>
      ) : (
        <>
          {welcomeName ? (
            <p className="app-hero__eyebrow">Welcome, {welcomeName}</p>
          ) : (
            <p className="app-hero__eyebrow">VitalStaf for clinicians</p>
          )}

          <h1 className="app-hero__title">{title}</h1>
          <p className="app-hero__subtitle">{subtitle}</p>

          <div className="app-hero__features">
            {FEATURES.map((feature) => (
              <div key={feature.label} className="app-hero__feature">
                <span className="app-hero__feature-icon">{feature.icon}</span>
                <span className="app-hero__feature-label">{feature.label}</span>
              </div>
            ))}
          </div>

          {showOpenInApp ? (
            <div className="app-hero__actions">
              <button type="button" className="app-hero__btn app-hero__btn--primary" onClick={onOpenInApp}>
                <MobileOutlined />
                Open in VitalStaf app
              </button>
            </div>
          ) : null}

          <div className="app-hero__actions app-hero__actions--stores">
            <a
              href="https://link.vitalstaf.com/ios"
              target="_blank"
              rel="noopener noreferrer"
              className="app-hero__btn app-hero__btn--primary"
            >
              <AppleFilled />
              Download on iOS
            </a>
            <a
              href="https://link.vitalstaf.com/android"
              target="_blank"
              rel="noopener noreferrer"
              className="app-hero__btn app-hero__btn--primary"
            >
              <AndroidFilled />
              Get it on Android
            </a>
          </div>

          <p className="app-hero__hint">{hint}</p>

          {showProfileButton ? (
            <div className="app-hero__actions" style={{ marginTop: 20 }}>
              <button type="button" className="app-hero__btn app-hero__btn--ghost" onClick={onProfileClick}>
                <ProfileOutlined />
                Review / Edit Profile
              </button>
            </div>
          ) : null}
        </>
      )}
    </div>
  </section>
);

export default AppDownloadHero;
